<template>
  <div class="tw:bg-gray-100 tw:flex tw:w-full tw:px-6">
    <ul class="tw:flex tw:flex-row tw:justify-between tw:w-full tw:py-3">
      <li
        v-for="step in steps"
        :key="step.id"
        @click="goBack(step.id)"
        class="step tw:flex tw:gap-x-2 tw:items-center tw:justify-center"
        :class="getClasses(step.id)"
      >
        <span
          class="tw:flex tw:items-center tw:justify-center tw:text-sm tw:h-6 tw:w-6 tw:rounded-full tw:font-bold"
          :class="step.id <= activeStep ? 'tw:bg-blue-700 tw:text-white' : ' tw:bg-white tw:text-blue-700'"
          >{{ step.id + 1 }}</span
        >
        <span class="tw:text-xs">{{ $t(step.name) }}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
const props = defineProps({
  steps: Array,
  activeStep: Number,
  type: String,
})
const emit = defineEmits(['back'])
const goBack = step => {
  if (props.activeStep > step && props.type === 'edit') return
  if (step < props.activeStep) {
    emit('back', step)
  }
}

const getClasses = stepId => {
  const classes = []
  if (stepId === props.activeStep) {
    classes.push('tw:active-step tw:font-bold tw:text-blue-700')
  }
  if (props.activeStep > stepId && props.type === 'edit') {
    classes.push('tw:hover:cursor-default')
  } else if (stepId < props.activeStep) {
    classes.push('tw:hover:cursor-pointer')
  }
  return classes.join(', ')
}
</script>
<style scoped>
.step:first-child:after {
  content: '';
  width: 103px;
  height: 1px;
  background-color: var(--tw-color-gray-300);
  margin-left: 24px;
  margin-right: 24px;
}
.step:last-child:before {
  content: '';
  width: 103px;
  height: 1px;
  background-color: var(--tw-color-gray-300);
  margin-left: 24px;
  margin-right: 24px;
}
</style>
